import { Flex, Link, Text } from '@chakra-ui/react';
import { memo } from 'react';

import TransfersIntroCard from '@features/transfers/TransfersIntroCard';

const TransfersPage = () => {
  return (
    <Flex flexDir="column" gap={4} pt={8} px={4} h="full">
      <TransfersIntroCard />
      <Flex justifyContent="center">
        <Text fontSize="xs">
          Learn more about <Link variant="underline">transfers</Link>
        </Text>
      </Flex>
    </Flex>
  );
};

export default memo(TransfersPage);
